import * as React from "react";
import { XIcon, SearchIcon, LocationMarkerIcon } from "@heroicons/react/solid";
import images from "./assets/images";
import romanianCities from "./ro_cities";

interface SearchBarProps {
  searchText: string;
  setSearchText: (val: string) => void;
  selectedCity: string;
  setSelectedCity: (val: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchText,
  setSearchText,
  selectedCity,
  setSelectedCity,
}) => {
  const clearSearch = () => {
    setSearchText("");
  };

  return (
    <div className="flex items-center bg-white shadow-md rounded-searchBar w-full max-w-screen-lg mx-auto p-2 space-x-2">
      {/* Search input */}
      <div className="flex items-center flex-grow min-w-0">
        <div className="px-2">
          <img
            src={images.droneIcon}
            alt="Logo"
            className="h-4 w-4 sm:h-[18px] sm:w-[18px] text-gray-700"
          />
        </div>
        <input
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="PowerVisi"
          className="flex-grow bg-transparent outline-none text-gray-800 pl-2 text-sm sm:text-base min-w-0"
        />
        {searchText && (
          <button
            onClick={clearSearch}
            className="text-gray-400 hover:text-gray-600 transition px-2"
          >
            <XIcon className="h-4 w-4 sm:h-5 sm:w-5" />
          </button>
        )}
      </div>

      {/* City selector, styled to mimic input */}
      <div className="flex items-center relative rounded-md bg-transparent border-0 min-w-[160px]">
        <LocationMarkerIcon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400 absolute left-3 pointer-events-none" />
        <select
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
          className={`pl-8 pr-12 w-full h-[38px] text-sm sm:text-base rounded-md outline-none bg-transparent border-0
            font-normal min-w-[120px] max-w-[220px] appearance-none
            ${!selectedCity ? 'text-gray-400' : 'text-gray-700'} focus:ring-2 focus:ring-primary`}
        >
          <option value="" disabled>
            Choose a city
          </option>
          {romanianCities.map((city) => (
            <option key={city} value={city} className="text-gray-700">
              {city}
            </option>
          ))}
        </select>
        {/* Clear city button */}
        {selectedCity && (
          <button
            type="button"
            onClick={() => setSelectedCity("")}
            className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1 focus:outline-none z-10"
            tabIndex={-1}
            aria-label="Clear city"
          >
            <XIcon className="h-4 w-4 sm:h-5 sm:w-5" />
          </button>
        )}
        {/* Down arrow */}
        <svg
          className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400"
          width="16" height="16" fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path fillRule="evenodd" clipRule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.085l3.71-3.855a.75.75 0 0 1 1.08 1.04l-4.24 4.405a.75.75 0 0 1-1.08 0l-4.24-4.405a.75.75 0 0 1 .02-1.06z" fill="currentColor"/>
        </svg>
      </div>

      {/* Search button */}
      <button className="bg-button font-ubuntu font-medium text-white px-2 sm:px-4 py-1 sm:py-2 rounded-searchBar flex items-center space-x-1 hover:bg-indigo-800 transition">
        <SearchIcon className="h-4 w-4 sm:h-5 sm:w-5" />
        <span className="hidden sm:inline">Search</span>
      </button>
    </div>
  );
};

export default SearchBar;
